'use strict';

require('core-js/fn/array/includes');
require('core-js/fn/date/now');
require('core-js/fn/object/assign');
require('core-js/fn/object/keys');
require('core-js/fn/promise');
require('core-js/fn/symbol');

if (typeof requestAnimationFrame === 'undefined') {
    require('raf/polyfill');
}



// WEBPACK FOOTER //
// ./config/polyfills.js